import { AbstractPreset, config } from "./AbstractPreset";

export default class RoundedrectangleNoneEdges extends AbstractPreset {
	getName(): string {
		return 'roundedrectangleNoneEdges';
	}

	getConfig(): config {
		return {
			"base": {
				"shape": "rounded-rectangle",
				"presetShape": this.getName(),
				"primitives": {
					"width": 50,
					"length": 50,
					"radius": 2,
					"top_left_radius": 2,
					"top_right_radius": 2,
					"bottom_left_radius": 2,
					"bottom_right_radius": 2
				},
			},
			"drillholes": {
				"type": "edges",
				"edgeType": "corners",
				"offset": 30,
				"diameter": 20
			},
			"cutouts": [],
		};
	}
}
